import {
  ProductInterface,
  ProductVariantInterface,
} from 'common/types/entities/ProductInterface'
import { PricePlan } from 'common/types/OfferInterface'
import { usePayment } from 'publisher/store'
import {
  getOfferId,
  getOfferPricing,
} from 'publisher/store/payment/paymentSelectors'

export interface UseSelectedOfferPricing {
  selectedProduct?: ProductInterface | null
  selectedPricePlan?: PricePlan | null
  activeProductVariant?: ProductVariantInterface | null
}

export const useSelectedOfferPricing = ({
  selectedProduct,
  selectedPricePlan,
  activeProductVariant,
}: UseSelectedOfferPricing) => {
  const offerPricings = usePayment(getOfferPricing)
  const offerId = usePayment(getOfferId)

  if (!offerId || !offerPricings.length) {
    return
  }

  return offerPricings.find(calculatedPricing => {
    if (selectedPricePlan?.id === calculatedPricing.pricePlan) {
      return true
    } else if (
      activeProductVariant?.pricePlan.id === calculatedPricing.pricePlan
    ) {
      return true
    } else if (selectedProduct?.pricePlan.id === calculatedPricing.pricePlan) {
      return true
    }

    return false
  })
}
